import { useEffect, useRef } from "react";
import { useMap, useMapsLibrary } from "@vis.gl/react-google-maps";
import { useNavigate } from "react-router-dom";
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import { useSelector } from "react-redux";

const GeoMarkProcessor = ({ markers, isSolPoint, centerMap = true }) => {
  const markerLib = useMapsLibrary("marker");
  const map = useMap();
  const navigate = useNavigate();
  const clustererRef = useRef(null);
  const markerObjectsRef = useRef([]);
  const boundsRef = useRef(null);
  const userRole = useSelector((state) => state.user.userRole.name);

  console.log('markers', markers);
  const userLink = () => {
    if (userRole === 'client') {
      return "/client";
    } else if (userRole === 'admin' || userRole === 'superadmin') {
      return "/admin";
    } else if (userRole === 'domain_manager') {
      return "/domain-manager";
    } else if (userRole === 'exploitation_manager') {
      return "/exploitation-manager";
    }
  };

  useEffect(() => {
    if (!map || !markerLib) return;
    if (markers.length === 0) return;

    // Initialize MarkerClusterer
    clustererRef.current = new MarkerClusterer({ map });

    // Create a new LatLngBounds object
    boundsRef.current = new window.google.maps.LatLngBounds();

    markers.forEach(({ lat, lng, title, exploitation_id }) => {
      if (!lat || !lng) return;

      const position = new window.google.maps.LatLng(lat, lng);

      const mark = new markerLib.Marker({
        position: position,
        title: title,
        label: {
          text: `${title}`,
          color: "white",
          className: `bg-red-500 mb-10 p-2 rounded-lg`,
          optimized: true,
        },
      });

      mark.setIcon({
        url: "/marker.png",
      });

      mark.addListener("click", () => {
        if (isSolPoint) navigate(`${userLink()}/exploitation/${exploitation_id}/info/sol`);
        else navigate(`${userLink()}/map/exploitation/${exploitation_id}`);
      });

      markerObjectsRef.current.push(mark);

      // Extend the bounds to include this marker's position
      boundsRef.current.extend(position);
    });

    // Add markers to the clusterer
    clustererRef.current.addMarkers(markerObjectsRef.current);

    // Center the map if centerMap is true
    if (centerMap && boundsRef.current) {
      map.fitBounds(boundsRef.current);
    }

    return () => {
      if (clustererRef.current) {
        clustererRef.current.clearMarkers();
      }
      markerObjectsRef.current.forEach((mark) => {
        mark.setMap(null);
      });
      markerObjectsRef.current = [];
      boundsRef.current = null;
    };
  }, [map, markerLib, markers, navigate, centerMap]);

  return null;
};

export default GeoMarkProcessor;
